<div class="container">
    <mat-card>
        <mat-card-header>
            <mat-card-title class="mat-card-info" (click)="iaqDisplayToggle=!iaqDisplayToggle"><a href="javascript:">IAQ
                    Subscription History</a></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <table class="table" id="subscription-table">
                <tbody>
                    <tr>
                         <th>Event Date ({{ timezoneOffset }})</th>
                        <th>Subscription state</th>
                        <th>Notification Type</th>
                        <th>Product Id</th>
                        <th>Start Date ({{ timezoneOffset }})</th>
                        <th>Expiry Date ({{ timezoneOffset }})</th>
                        <th>Transaction ID</th>
                        <th>Original Transaction ID</th>
                        <th>Biller</th>
                        <th>Region</th>
                        <th>Currency Code</th>
                        <th>Units</th>
                        <th>User Initiated Cancellation</th>
                    </tr>
                    <tr *ngFor="let subscription of subscriptionsHistory">
                        <td>{{subscription.eventTime | date: dateFormat}}</td>
                        <td>{{subscription.subscriptionState}}</td>
                        <td>{{subscription.notificationType}}</td>
                        <td>{{subscription.productId}}</td>
                        <td>{{subscription.startTime | date: dateFormat}}</td>
                        <td>{{subscription.expiryTime | date: dateFormat}}</td>
                        <td>{{subscription.transactionId}}</td>
                        <td>{{subscription.originalTransactionId}}</td>
                        <td>{{subscription.biller}}</td>
                        <td>{{subscription.regionCode}}</td>
                        <td>{{subscription.currencyCode}}</td>
                        <td>{{subscription.units}}</td>
                        <td>{{subscription.userInitiatedCancellation | json }}</td>
                    </tr>
                </tbody>
            </table>
        </mat-card-content>
    </mat-card>
</div>